<template>
    <SelectSearchInput
        :list="localPhoneCountryCodeList"
        :value="value"
        :name="name"
        :useBookingFormThemeCssVariables="useBookingFormThemeCssVariables"
        :required="required"
        :disabled="disabled"
        @onSelectionChange="
            emit('onPhoneCountryCodeSelectionChange', { value: $event.value })
        "
    />
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import { CountryPhoneCodeList } from '@/Shared/AutoGenerated/CountryPhoneCodeList'
    import type { SearcheableEntity } from '@/Shared/Component/Forms/SelectSearchInput.vue'
    import SelectSearchInput from '@/Shared/Component/Forms/SelectSearchInput.vue'

    const emit = defineEmits<{
        onPhoneCountryCodeSelectionChange: [{ value: string }]
    }>()

    const props = defineProps({
        name: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: null,
        },
        useBookingFormThemeCssVariables: {
            type: Boolean,
            required: true,
        },
        required: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    })

    const phoneCountryCodeList = CountryPhoneCodeList.map(
        (item): SearcheableEntity => {
            return {
                id: `${item.code}-(${item.countryName})`.toLowerCase(),
                value: item.code,
                displayText: `+${item.code} (${item.countryName})`,
            }
        },
    )
    const localPhoneCountryCodeList =
        ref<SearcheableEntity[]>(phoneCountryCodeList)
</script>
